export type OttTokenPayload = {
  type?: string;
  accountId?: string;
  projectId?: string;
  filters?: unknown[];
  iat?: number;
  exp?: number;
};

/**
 * Decodes a JWT payload WITHOUT verifying the signature (base64 only). The
 * embed only needs to read `projectId` to fill request payloads — the
 * backend verifies the token and derives/vets the project server-side.
 */
export function decodeTokenPayload(token: string): OttTokenPayload | null {
  const payload = token.split('.')[1];
  if (!payload) {
    return null;
  }
  try {
    const base64 = payload.replaceAll('-', '+').replaceAll('_', '/');
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '=',
    );
    const binary = atob(padded);
    // Decode UTF-8 byte sequences (project names etc. may be non-ASCII).
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const json = new TextDecoder().decode(bytes);
    const parsed: unknown = JSON.parse(json);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    return parsed as OttTokenPayload;
  } catch {
    return null;
  }
}

export function decodeProjectId(token: string): string | null {
  const payload = decodeTokenPayload(token);
  return typeof payload?.projectId === 'string' ? payload.projectId : null;
}
